import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../components/ui/tooltip";
import { useAuth } from "../context/AuthContext";
import { HelpCircle, LogOut } from "lucide-react";

export default function Sidebar() {
  const { logout } = useAuth();

  return (
    <TooltipProvider>
      <aside className="bg-white border-r border-gray-200 flex-shrink-0 w-16 flex flex-col h-full z-50 shadow-sm">
        {/* Spacer at top */}
        <div className="flex-1"></div>

        {/* All Options at Bottom */}
        <div className="p-2 space-y-2 bg-white border-t border-gray-200 flex-shrink-0">
          {/* Help */}
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                className="w-12 h-12 rounded-lg hover:bg-gray-100 flex items-center justify-center"
                asChild
              >
                <Link to="/help" className="flex items-center justify-center">
                  <HelpCircle className="h-5 w-5 text-gray-700" />
                </Link>
              </Button>
            </TooltipTrigger>
            <TooltipContent side="right">
              <p>Help & Support</p>
            </TooltipContent>
          </Tooltip>

          {/* Logout */}
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                className="w-12 h-12 rounded-lg hover:bg-red-50 text-red-600 hover:text-red-700 flex items-center justify-center"
                onClick={logout}
              >
                <LogOut className="h-5 w-5" />
              </Button>
            </TooltipTrigger>
            <TooltipContent side="right">
              <p>Logout</p>
            </TooltipContent>
          </Tooltip>
        </div>
      </aside>
    </TooltipProvider>
  );
}
